import { Box, Button, Divider, List, ListItem, Typography } from "@material-ui/core"
import { Add } from "@material-ui/icons"
import { useMemo } from "react"
import { ehProdutoAdicionais, useCardapioContext } from "./CardapioContext"
import ItemPasso from "./ItemPasso"

// Seção de "passos comuns" embutida no popup de edição da categoria.
// Os passos ficam num produto especial "Adicionais" (ordemExib = -99999) que o
// backend replica em todos os produtos da categoria. Reutiliza o fluxo de passo.
export default function SecaoPassosComuns({ categoria }) {
    const {
        categorias,
        garantirProdutoAdicionais,
        setCadastrar,
        setModalPasso,
        setProdutoAtual,
        setOpenPassoDeMontagem,
    } = useCardapioContext()

    // Lê o produto Adicionais do estado (reflete passos adicionados/removidos).
    const adicionais = useMemo(() => {
        const cat = categorias?.find(c => c.id === categoria?.id)
        return cat?.produtos?.find(ehProdutoAdicionais) || null
    }, [categorias, categoria?.id])

    const passos = useMemo(() => {
        const o = adicionais?.opcoes ?? []
        return [...o].sort((a, b) => a.ordemExib - b.ordemExib)
    }, [adicionais?.opcoes])

    // Cria o produto Adicionais só ao adicionar o primeiro passo (evita produtos vazios).
    const handleAddPasso = async () => {
        let prod = adicionais
        if (!prod) prod = await garantirProdutoAdicionais(categoria.id)
        if (!prod) return
        setCadastrar(true)
        setModalPasso(null)
        setProdutoAtual(prod)
        setOpenPassoDeMontagem(true)
    }

    return (
        <Box mt={2}>
            <Divider />
            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                mt={2}
                mb={1}
                style={{ gap: 8 }}
            >
                <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                    Passos comuns da categoria
                </Typography>
                <Button
                    type="button"
                    variant="contained"
                    startIcon={<Add />}
                    onClick={handleAddPasso}
                    style={{ backgroundColor: "#14A44D", color: "white", textTransform: "none" }}
                >
                    Adicionar passo comum
                </Button>
            </Box>
            <Typography variant="body2" style={{ color: "#6b7280", marginBottom: 8 }}>
                Valem para <strong>todos os produtos desta categoria</strong> — adicionados
                automaticamente a cada produto, além dos passos próprios de cada um.
            </Typography>

            {passos.length === 0 ? (
                <Typography align="center" style={{ color: "#9ca3af", padding: "16px 0" }}>
                    Nenhum passo comum cadastrado ainda.
                </Typography>
            ) : (
                <List>
                    {passos.map(opcao => (
                        <ListItem key={opcao.id} disableGutters>
                            <ItemPasso opcao={opcao} conteudo={adicionais} />
                        </ListItem>
                    ))}
                </List>
            )}
        </Box>
    )
}
